/**
 * @description
 */

import './progressiveEmg.scss';

import React, { useState, useEffect } from 'react';
import { $window } from '@umu/umu-dom';
import Emg, { EmgFit, LOADING_IMG } from '../emg/emg';

export { EmgFit } from '../emg/emg';

interface IProps {
    src: string;
    previewSrc: string;
    className?: string;
    fit?: EmgFit;
    onLoad?: (event: Event) => void;
}

export default function ProgressiveEmg(props: IProps) {
    const [isAnimating, setIsAnimating] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [timer, setTimer] = useState(0);

    useEffect(() => {
        return () => {
            clearTimeout(timer);
        };
    }, []);

    useEffect(() => {
        setIsAnimating(false);
        setIsLoaded(false);
    }, [props.previewSrc]);

    const onLoad = (e: Event): void => {
        setIsAnimating(true);

        // 应该在图片展示完成后设置，不过简单点延迟 100ms 吧
        setTimer(
            $window.setTimeout(() => {
                setIsLoaded(true);
            }, 100),
        );

        if (props.onLoad) {
            props.onLoad(e);
        }
    };

    const renderPreview = () => {
        const { fit } = props;
        let { previewSrc } = props;

        if (isLoaded) {
            return null;
        }

        if (!previewSrc) {
            previewSrc = LOADING_IMG;
        }

        return (
            <div className={'progressive-emg-preview' + (isAnimating ? ' is-animating' : '')}>
                <Emg src={previewSrc} fit={fit}></Emg>
            </div>
        );
    };

    const renderImg = () => {
        const { src, fit } = props;

        if (!src) {
            return null;
        }

        return (
            <div className={'progressive-emg-img' + (isAnimating ? ' is-animating' : '')}>
                <Emg src={src} fit={fit} onLoad={onLoad} onError={onLoad}></Emg>
            </div>
        );
    };

    const render = () => {
        return (
            <div className={'progressive-emg ' + (props.className || '')}>
                {renderPreview()}
                {renderImg()}
            </div>
        );
    };

    return render();
}
